export default __webpack_public_path__ + "static/media/edufyPic.0febdaff.png";